export default __webpack_public_path__ + "static/media/vip-10.bb6973d6.svg";